import { useNavigate } from "react-router-dom";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import OrderService from "../Services/OrderService";
import { useCartContext } from "../Contexts/CartContext";
import { useLayoutContext } from "../Contexts/LayoutContext";
import { useStoreHook } from "./StoreHook";
import { useTranslation } from "react-i18next";
import { useLoginContext } from "../Contexts/LoginContext";
import CustomerService from "../Services/CustomerService";
import { useCheckoutContext } from "../Contexts/CheckoutContext";
import { ORDER_STATUS_AWAITING_PAYMENT, ORDER_STATUS_CANCELED, ORDER_STATUS_DONE, ORDER_STATUS_EXPEDITED, ORDER_STATUS_EXPIRED, ORDER_STATUS_MOUNTING, ORDER_STATUS_PENDING, ORDER_STATUS_RELEASED_SHIPMENT, ORDER_STATUS_RELEASED_TAKEAWAY } from "../Utils/Constants/Checkout";
import { ORDER_TYPE_STORE_COUNTER_ID } from "../Utils/Constants/Service";

export const useOrderHook = () => {

    const { t } = useTranslation();
    const { orderType } = useOrderTypeContext();
    const { user } = useLoginContext();

    const { setOrdersTodayList, setAwaitingOrPendingCount } = useCheckoutContext();
    const { setCurrentOrder, setShowOrderDetail, setLoadingOrderDetail, setCurrentOrderId, setShowCart, cartDisplay } = useCartContext();
    const { setMainLoading, setMainLoadingIcon, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, setShowTodayOrders, setIsCartInfoViewed, setShowSearchBar } = useLayoutContext();
    const { getLinkToHome } = useStoreHook();
    const navigate = useNavigate();

    const getOrderDetail = async (order_id: number) => {

        const payload = {
            order_id: order_id,
        }
        setShowOrderDetail(true);
        setLoadingOrderDetail(true);

        try {
            const orderService = new OrderService(orderType);
            const details = await orderService.detail(payload);

            if (details) {
                setCurrentOrder(details);
            }
        } catch (error) {
            setShowOrderDetail(false);
            // setLoadingOrderDetail(false);

            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoadingTitle(t('errors.default_title'));
            setMainLoadingMessage(t('errors.default_message'));
            setMainLoadingCloseButton(true);
        } finally {
            setLoadingOrderDetail(false);
        }
    }

    const getOrdersToday = async () => {
        const payload = {
            user_id: user.id,
        };

        try {
            const customerService = new CustomerService(orderType);
            const response = await customerService.getCustomerOrdersToday(payload);

            if (response.data) {
                setOrdersTodayList(response.data);
                const total = response.data.filter((order: any) =>
                    [
                        ORDER_STATUS_AWAITING_PAYMENT,
                        ORDER_STATUS_PENDING,
                        ORDER_STATUS_MOUNTING,
                        ORDER_STATUS_RELEASED_SHIPMENT,
                        ORDER_STATUS_RELEASED_TAKEAWAY,
                        ORDER_STATUS_EXPEDITED
                    ].includes(Number(order.status))
                ).length;
                setAwaitingOrPendingCount(total);
            }
        } catch (error: any) {
        } finally {}
    }

    const goToOrderView = (order_id: number) => {
        navigate(`${getLinkToHome()}/order/${order_id}/view`);
    }

    const handleShowDetailStoreCounter = (order: any) => {
        if (Number(order.status) === ORDER_STATUS_DONE) {
            getOrderDetail(order.id);
            setShowOrderDetail(true);
        } else if (Number(order.status) === ORDER_STATUS_EXPIRED || Number(order.status) === ORDER_STATUS_AWAITING_PAYMENT || Number(order.status) === ORDER_STATUS_CANCELED) {
            goToOrderView((order.id));
            setShowOrderDetail(false);
            setShowTodayOrders(false);
        } else {
            //*! Se existir um carrinho atual, mostrar o carrinho (problema ao trocar de serviço)
            if (cartDisplay) {
                setShowCart(true);
            }
            setShowOrderDetail(false);
        }
    }

    const handleGetDetail = (order: any) => {
        if (order.type === ORDER_TYPE_STORE_COUNTER_ID) {
            handleShowDetailStoreCounter(order);
        } else {
            setShowOrderDetail(true);
            setCurrentOrderId(order.id);
            setLoadingOrderDetail(false);
        }
    }

    const handleShowCart = (order: any) => {
        if (order) {
            if (order.type === ORDER_TYPE_STORE_COUNTER_ID) {
                handleShowDetailStoreCounter(order);
            } else {
                goToOrderView((order.id));
            }
        } else {
            setShowCart(true);
        }
        setIsCartInfoViewed(true);
        setShowSearchBar(false);
    }

    return {
        getOrderDetail,
        goToOrderView,
        getOrdersToday,
        handleGetDetail,
        handleShowDetailStoreCounter,
        handleShowCart
    };
}